import axiosInstance from "../../api/axios";
import toBase64 from "../../utils/image";
import { IEssayBody } from "../../models/essay";
import TrackEventsUser from '../../track/trackEventsUser';

export async function createEssay(body: { theme: string, moduleOrigin: string }) {
  try {
    const response = await axiosInstance.post(`/essays-online`, body);

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function saveEssay(body: IEssayBody) {
  try {
    const response = await axiosInstance.put(`/essays-online/${body.theme}`, body);

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function saveImage(file: File, user: string) {
  try {
    const prefix = new Date().valueOf();
    const fileName = `${prefix}-${file.name}`;
    const path = `essays/${user}`;

    const body = { file: await toBase64(file), fileName, path }
    const { data } = await axiosInstance.post(`/upload`, body);

    return data;
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function sendEssay(body: IEssayBody) {
  try {
    const responseSave = await axiosInstance.put(`/essays-online/${body.theme}`, body);
    let response = {} as any;

    if(responseSave.data._id && responseSave.data.status === 'writing') {
      const essayId = responseSave.data._id;
      const { data } = await axiosInstance.post(`/essays-online/correction/${essayId}`)
      response = data;

      TrackEventsUser("ESSAY_SEND_CORRECTION", "v2")
    }

    return response;
  } catch(e: any) {
    throw new Error(e);
  }
}

export async function getEssayByUser(slug: string, tryNumber?: number) {
  try {
    const url = tryNumber ? `/essays/${slug}?tryNumber=${tryNumber}` : `/essays/${slug}`;
    const response = await axiosInstance.get(url);

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}
